import * as yup from 'yup';

export const parsePrice = (value) => {
  const normalized = String(value ?? '').replace(/\s/g, '');
  return normalized === '' ? undefined : Number(normalized);
};

export const applicationSchema = yup.object().shape({
  firstName: yup.string().trim().required('First name is required field'),
  lastName: yup.string().trim().required('Last name is required field'),
  pricePerHour: yup
    .number()
    .transform((_, originalValue) => parsePrice(originalValue))
    .typeError('Price per hour must be a number')
    .required('Price per hour is required field')
    .positive('Price per hour must be greater than 0'),
  cv: yup.mixed().required('CV is required field'),
  files: yup.array().max(10, 'You can attach at most 10 additional files'),
  motivation: yup.string(),
  contactUserID: yup.number().typeError('Contact is required field').required('Contact is required field'),
  placeIDs: yup.array().of(yup.string()),
  preferredPlaceID: yup.string().when('placeIDs', {
    is: (placeIDs) => placeIDs?.length > 1,
    then: (schema) =>
      schema
        .required('Preferred location is required field')
        .test('is-job-ad-location', 'Preferred location must be one of the job ad locations', (value, { parent }) =>
          !value || parent.placeIDs.includes(value)
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
});
